import type {
  DraggableFieldType,
  DraggableMetaType,
  FieldWrapper,
  GroupingField,
  ReportField,
} from "../../../../../../../../../api/types/svTypes.ts";
import { isAggregation, isMeasure } from "../../../../../utilities/fieldsHelper.ts";
import { extractMeta } from "../../../common/utilities/dropFieldContainerHelper.ts";
import { isReferenceDateField } from "../../../common/utilities/isReferenceDateField.ts";
import { isDimensionMeta } from "../../../common/utilities/metaUtils.ts";

export const canDropItem = (
  item: FieldWrapper<DraggableFieldType> | DraggableMetaType,
  fields: ReportField[],
  grouping: GroupingField[]
) => {
  const meta = extractMeta(item);
  if (!meta) return false;
  if (isDimensionMeta(meta)) {
    if (isReferenceDateField(meta)) {
      return (
        // An aggregation over a reference-date dimension is a value column, not the report's reference date.
        !fields.some((v) => isReferenceDateField(v.meta) && !isAggregation(v)) &&
        !grouping.some((v) => {
          const field = fields.find((f) => f.config.guid === v.id);
          return field && isMeasure(field);
        })
      );
    }
    return true;
  }
  return true;
};
